(function (w) {
	"use strict";

	let KEY = "ws_attrib_v1";
	let TTL_MS = 7 * 24 * 60 * 60 * 1000; // 7 днів

	function now() { return Date.now(); }

	function safeJsonParse(s) { try { return JSON.parse(s); } catch (e) { return null; } }
	function safeJsonStringify(o) { try { return JSON.stringify(o); } catch (e) { return null; } }

	function hasAdClick(sb_current_add) {
		let ep = sb_current_add && sb_current_add.ep ? String(sb_current_add.ep) : "";
		return /[?&](gclid|yclid|fbclid)=/i.test(ep);
	}
	function hasUtm(sb_current) {
		if (!sb_current) return false;
		// sourcebuster typ='utm'
		return sb_current.typ === "utm";
	}
	function isDirect(sb_current) {
		if (!sb_current) return true;
		// sourcebuster: typein + (direct)/(none)
		return (sb_current.typ === "typein") || (sb_current.src === "(direct)" && sb_current.mdm === "(none)");
	}

	// {
	//   v:1, exp, ts,
	//   first:  { typ,src,mdm,cmp,cnt,trm, ...? },
	//   current:{ typ,src,mdm,cmp,cnt,trm, ...? },
	//   current_add:{ fd,ep,rf },
	//   extra:{ adid, matchtype, ... },
	//   meta:{ last_host, last_source }
	// }

	function normalizeFromSbjsWsjs(sb, extra) {
		// sb = sbjs.get
		let out = {
			first: sb && sb.first ? sb.first : null,
			current: sb && sb.current ? sb.current : null,
			current_add: sb && sb.current_add ? sb.current_add : null,
			extra: extra || null
		};
		return out;
	}

	function mergeExtra(oldEx, newEx) {
		if (!newEx) return oldEx || null;
		if (!oldEx) return newEx;

		let res = {};
		let k;
		for (k in oldEx) res[k] = oldEx[k];

		for (k in newEx) {
			if (!Object.prototype.hasOwnProperty.call(newEx, k)) continue;
			let v = newEx[k];
			if (v == null || v === "") continue;
			if (res[k] == null || res[k] === "") res[k] = v;
		}
		return res;
	}

	function mergeAttrib(oldWrap, incNorm, meta) {
		let old = oldWrap || null;
		let res = old ? old.data : null;

		if (!res) {
			return {
				v: 1,
				ts: now(),
				exp: now() + TTL_MS,
				data: {
					first: incNorm.first || null,
					current: incNorm.current || null,
					current_add: incNorm.current_add || null,
					extra: incNorm.extra || null,
					meta: meta || null
				}
			};
		}

		if (!res.first && incNorm.first) res.first = incNorm.first;

		let incStrong = hasUtm(incNorm.current) || hasAdClick(incNorm.current_add);
		let oldDirect = isDirect(res.current);
		let incDirect = isDirect(incNorm.current);

		if (incStrong) {
			if (incNorm.current) res.current = incNorm.current;
			if (incNorm.current_add) res.current_add = incNorm.current_add;
		} else {
			if (oldDirect && !incDirect) {
				if (incNorm.current) res.current = incNorm.current;
				if (incNorm.current_add) res.current_add = incNorm.current_add;
			}
		}

		res.extra = mergeExtra(res.extra, incNorm.extra);

		res.meta = res.meta || {};
		if (meta) {
			for (let k in meta) res.meta[k] = meta[k];
		}

		return {
			v: 1,
			ts: now(),
			exp: now() + TTL_MS,
			data: res
		};
	}

	function validateWrap(wrap) {
		if (!wrap || wrap.v !== 1) return null;
		if (wrap.exp && wrap.exp < now()) return null;
		if (!wrap.data) return null;
		return wrap;
	}

	function byteLen(str) {
		try { return new Blob([str]).size; } catch (e) { return (str || "").length; }
	}

	// size guard
	function shrinkIfNeeded(wrap, maxBytes) {
		let raw = safeJsonStringify(wrap);
		if (!raw) return null;
		if (byteLen(raw) <= maxBytes) return raw;

		let copy = safeJsonParse(raw);
		if (copy && copy.data) {
			delete copy.data.meta;
			raw = safeJsonStringify(copy);
			if (raw && byteLen(raw) <= maxBytes) return raw;

			delete copy.data.extra;
			raw = safeJsonStringify(copy);
			if (raw && byteLen(raw) <= maxBytes) return raw;

			delete copy.data.current_add;
			raw = safeJsonStringify(copy);
			if (raw && byteLen(raw) <= maxBytes) return raw;

			copy.data = { current: copy.data.current || null };
			raw = safeJsonStringify(copy);
			if (raw && byteLen(raw) <= maxBytes) return raw;
		}

		return null;
	}

	// Same-origin localStorage. Kept Promise-based so the callers (footer, qualify, 4xx/5xx)
	// did not have to change when the cross-subdomain iframe bridge was removed.
	let store = {
		get: function (key) {
			return new Promise(function (resolve) {
				try { resolve(localStorage.getItem(key)); } catch (e) { resolve(null); }
			});
		},
		set: function (key, value) {
			return new Promise(function (resolve, reject) {
				try { localStorage.setItem(key, String(value)); resolve(); } catch (e) { reject(e); }
			});
		},
		remove: function (key) {
			return new Promise(function (resolve) {
				try { localStorage.removeItem(key); } catch (e) {}
				resolve();
			});
		}
	};

	async function load() {
		let raw = await store.get(KEY);
		let wrap = validateWrap(safeJsonParse(raw));
		if (!wrap) {
			try { await store.remove(KEY); } catch (e) {}
			return null;
		}
		return wrap;
	}

	async function saveMerge(sb, extra, opts) {
		opts = opts || {};
		let maxBytes = opts.maxBytes || (16 * 1024);

		let oldRaw = await store.get(KEY);
		let oldWrap = validateWrap(safeJsonParse(oldRaw));

		let incNorm = normalizeFromSbjsWsjs(sb, extra);
		let meta = {
			last_host: location.hostname,
			last_source: opts.source || null
		};

		let mergedWrap = mergeAttrib(oldWrap, incNorm, meta);

		let raw = shrinkIfNeeded(mergedWrap, maxBytes);
		if (!raw) return false;

		await store.set(KEY, raw);
		return true;
	}

	w.WSAttribStore = {
		load: load,
		saveMerge: saveMerge,
		clear: async function () {
			await store.remove(KEY);
		}
	};
})(window);